"use strict";

require("core-js/modules/es.object.values");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledSystem = require("styled-system");

var _spaceVariants = _interopRequireDefault(require("./spaceVariants"));

var _responsiveVariantVal, _variants, _variants2, _variants3, _variants4, _variants5, _variants6;

var responsiveVariantValues = (_responsiveVariantVal = {}, _responsiveVariantVal[_spaceVariants.default.COMPACT] = {
  mx: [.5, .5, .5, 1, 1.5, 1.5],
  my: [.5, .5, .5, 1, 1.5, 1.5]
}, _responsiveVariantVal[_spaceVariants.default.NORMAL] = {
  mx: [1, 1, 1, 1.5, 2, 2],
  my: [1, 1, 1, 1.5, 2, 2]
}, _responsiveVariantVal[_spaceVariants.default.COMFORT] = {
  mx: [1.5, 1.5, 1.5, 2, 2.5, 2.5],
  my: [1.5, 1.5, 1.5, 2, 2.5, 2.5]
}, _responsiveVariantVal);
var margin = (0, _styledSystem.variant)({
  prop: "mv",
  variants: responsiveVariantValues
});
margin.propTypes = {
  mv: _propTypes.default.oneOf(Object.values(_spaceVariants.default))
};
var marginT = (0, _styledSystem.variant)({
  prop: "mtv",
  variants: (_variants = {}, _variants[_spaceVariants.default.COMPACT] = {
    mt: responsiveVariantValues[_spaceVariants.default.COMPACT].my
  }, _variants[_spaceVariants.default.NORMAL] = {
    mt: responsiveVariantValues[_spaceVariants.default.NORMAL].my
  }, _variants[_spaceVariants.default.COMFORT] = {
    mt: responsiveVariantValues[_spaceVariants.default.COMFORT].my
  }, _variants)
});
marginT.propTypes = {
  mtv: _propTypes.default.oneOf(Object.values(_spaceVariants.default))
};
var marginB = (0, _styledSystem.variant)({
  prop: "mbv",
  variants: (_variants2 = {}, _variants2[_spaceVariants.default.COMPACT] = {
    mb: responsiveVariantValues[_spaceVariants.default.COMPACT].my
  }, _variants2[_spaceVariants.default.NORMAL] = {
    mb: responsiveVariantValues[_spaceVariants.default.NORMAL].my
  }, _variants2[_spaceVariants.default.COMFORT] = {
    mb: responsiveVariantValues[_spaceVariants.default.COMFORT].my
  }, _variants2)
});
marginB.propTypes = {
  mbv: _propTypes.default.oneOf(Object.values(_spaceVariants.default))
};
var marginX = (0, _styledSystem.variant)({
  prop: "mxv",
  variants: (_variants3 = {}, _variants3[_spaceVariants.default.COMPACT] = {
    mx: responsiveVariantValues[_spaceVariants.default.COMPACT].mx
  }, _variants3[_spaceVariants.default.NORMAL] = {
    mx: responsiveVariantValues[_spaceVariants.default.NORMAL].mx
  }, _variants3[_spaceVariants.default.COMFORT] = {
    mx: responsiveVariantValues[_spaceVariants.default.COMFORT].mx
  }, _variants3)
});
marginX.propTypes = {
  mxv: _propTypes.default.oneOf(Object.values(_spaceVariants.default))
};
var marginY = (0, _styledSystem.variant)({
  prop: "myv",
  variants: (_variants4 = {}, _variants4[_spaceVariants.default.COMPACT] = {
    my: responsiveVariantValues[_spaceVariants.default.COMPACT].my
  }, _variants4[_spaceVariants.default.NORMAL] = {
    my: responsiveVariantValues[_spaceVariants.default.NORMAL].my
  }, _variants4[_spaceVariants.default.COMFORT] = {
    my: responsiveVariantValues[_spaceVariants.default.COMFORT].my
  }, _variants4)
});
marginY.propTypes = {
  myv: _propTypes.default.oneOf(Object.values(_spaceVariants.default))
};
var marginL = (0, _styledSystem.variant)({
  prop: "mlv",
  variants: (_variants5 = {}, _variants5[_spaceVariants.default.COMPACT] = {
    ml: responsiveVariantValues[_spaceVariants.default.COMPACT].mx
  }, _variants5[_spaceVariants.default.NORMAL] = {
    ml: responsiveVariantValues[_spaceVariants.default.NORMAL].mx
  }, _variants5[_spaceVariants.default.COMFORT] = {
    ml: responsiveVariantValues[_spaceVariants.default.COMFORT].mx
  }, _variants5)
});
marginL.propTypes = {
  mlv: _propTypes.default.oneOf(Object.values(_spaceVariants.default))
};
var marginR = (0, _styledSystem.variant)({
  prop: "mrv",
  variants: (_variants6 = {}, _variants6[_spaceVariants.default.COMPACT] = {
    mr: responsiveVariantValues[_spaceVariants.default.COMPACT].mx
  }, _variants6[_spaceVariants.default.NORMAL] = {
    mr: responsiveVariantValues[_spaceVariants.default.NORMAL].mx
  }, _variants6[_spaceVariants.default.COMFORT] = {
    mr: responsiveVariantValues[_spaceVariants.default.COMFORT].mx
  }, _variants6)
});
marginR.propTypes = {
  mrv: _propTypes.default.oneOf(Object.values(_spaceVariants.default))
};

var _default = (0, _styledSystem.compose)(margin, marginX, marginY, marginT, marginR, marginB, marginL);

exports.default = _default;